import { ChainedSchema } from '../../general/ChainedSchema';
const obsoleteTraitKeys = ['textLanguage', 'isContained'];
class SerializrType_removeObsoleteTraitKeys extends ChainedSchema {
    registryType;
    constructor(propSchema) {
        super(propSchema);
    }
    deserializer(context) {
        const value = context.json;
        if (value.find(trait => obsoleteTraitKeys.includes(trait.key))) {
            context.json_overwrite = value.filter(trait => !obsoleteTraitKeys.includes(trait.key));
        }
        return this.parentSchema.deserializer(context);
    }
}
export function removeObsoleteTraitKeys(propSchema) {
    return new SerializrType_removeObsoleteTraitKeys(propSchema);
}
